module.exports = __webpack_public_path__ + "img/person.f9692cc3.png";